export default __webpack_public_path__ + "static/media/successIcon.463179e5.gif";